import { ApiResourceBaseClass as $ } from "./baseApiCalls.js";
import { BUSINESS_RESOURCE_URI as a } from "./business.js";
const r = "services", c = `free_form_${r}`, i = `structured_${r}`;
class d extends $ {
  /**
   * Checks if services are available for a given business.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/business/${businessId}/is_services_available`
   *
   * @param {string} businessId - The ID of the business to check.
   * @returns {Promise<boolean>} A promise that resolves to a boolean indicating whether services are available.
   */
  isServicesAvailable = async (t) => {
    const { data: e } = await this.get(
      `${a}/${t}/is_services_available`
    );
    return e;
  };
  /**
   * Fetches the services for a given business.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/business/${businessId}/services`
   *
   * @param {string} businessId - The ID of the business for which to fetch services.
   * @returns {Promise<ServicesGetDataType>} A promise that resolves to the data of the services.
   */
  getServices = async (t) => {
    const { data: e } = await this.get(
      `${a}/${t}/${r}`
    );
    return e;
  };
  /**
   * Fetches service suggestions based on the provided query parameters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/services/suggestions?${queryParams}`
   *
   * @param {ServiceSuggestionGetParamsType} queryParams - The parameters to filter the service suggestions.
   * @returns {Promise<ServicesSuggestionsGetDataType>} A promise that resolves to the service suggestions data.
   */
  getServicesSuggestions = async (t) => {
    const { data: e } = await this.get(
      `${r}/suggestions`,
      t
    );
    return e;
  };
  /**
   * Fetches service suggestions based on the provided category, country, and language.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/services/suggestions_category?category=${category}&country=${country}&lang=${lang}`
   *
   * @param {string} category - The category for which to fetch service suggestions.
   * @param {string} country - The country code to filter the service suggestions.
   * @param {string} lang - The language code to filter the service suggestions.
   * @returns {Promise<ServicesSuggestionsGetDataType>} A promise that resolves to the service suggestions data.
   */
  getServicesSuggestionsCategory = async (t, e, s) => {
    const n = { category: t, country: e, lang: s }, { data: o } = await this.get(
      `${r}/suggestions_category`,
      n
    );
    return o;
  };
  /**
   * Deletes a service for a given business.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/business/${businessId}/services/${serviceId}`
   *
   * @param {string} businessId - The ID of the business.
   * @param {number} serviceId - The ID of the service to be deleted.
   * @returns {Promise<SuccessResponse>} A promise that resolves to a SuccessResponse object.
   */
  deleteService = async (t, e) => {
    const { data: s } = await this.delete(
      `${a}/${t}/${r}/${e}`
    );
    return s;
  };
  /**
   * Creates a structured service for a given business.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/business/${businessId}/structured_services`
   *
   * @param {string} businessId - The ID of the business for which the structured service is being created.
   * @param {StructuredServiceCreateParamsType} queryParams - The parameters required to create the structured service.
   * @returns {Promise<ServicesGetDataType>} A promise that resolves to the data of the created structured service.
   */
  createStructuredService = async (t, e) => {
    const { data: s } = await this.post(
      `${a}/${t}/${i}`,
      e
    );
    return s;
  };
  /**
   * Creates a free form service for a given business.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/business/${businessId}/free_form_services`
   *
   * @param {string} businessId - The ID of the business for which the service is being created.
   * @param {FreeFormServiceCreateParamsType} queryParams - The parameters required to create the free form service.
   * @returns {Promise<ServicesGetDataType>} A promise that resolves to the created service data.
   */
  createFreeFormService = async (t, e) => {
    const { data: s } = await this.post(
      `${a}/${t}/${c}`,
      e
    );
    return s;
  };
  /**
   * Updates a structured service for a given business.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/business/${businessId}/structured_services`
   *
   * @param {string} businessId - The ID of the business to update the service for.
   * @param {StructuredServiceUpdateParamsType} queryParams - The parameters for updating the structured service.
   * @returns {Promise<ServicesGetDataType>} A promise that resolves to the updated service data.
   */
  updateStructuredService = async (t, e) => {
    const { data: s } = await this.post(
      `${a}/${t}/${i}`,
      e
    );
    return s;
  };
  /**
   * Updates a free form service for a given business.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/business/${businessId}/free_form_services`
   *
   * @param {string} businessId - The ID of the business to update the service for.
   * @param {FreeFormServiceUpdateParamsType} queryParams - The parameters for updating the free form service.
   * @returns {Promise<ServicesGetDataType>} A promise that resolves to the updated service data.
   */
  updateFreeFormService = async (t, e) => {
    const { data: s } = await this.post(
      `${a}/${t}/${c}`,
      e
    );
    return s;
  };
}
export {
  d as Services
};
